import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ModeratAnfrage } from '../anfrage/moderat.anfrage';
import { ResultDataCosts, FinanzierungsTyp } from '../interfaces/result-data.interface';

/**
 * Show the cost overview in the sidebar of the result üage of the moc
 */
@Component({
    selector: 'app-sanierung-costs-overview',
    templateUrl: './sanierung-costs-overview.component.html',
    standalone: false
})
export class SanierungCostsOverviewComponent {
  /**
   * Toggle the loading indicators
   */
  @Input() loading: boolean;

  /**
   * cost data
   */
  @Input() costs: ResultDataCosts;

  /**
   * the request object
   */
  @Input() anfrage: ModeratAnfrage;

  /**
   * financial data
   */
  @Input() financing: FinanzierungsTyp;

  /**
   * eventhandler for the click on the details link
   */
  @Output() financeDetails = new EventEmitter<void>();

  // Common translation key prefix
  readonly textkeyPrefix = 'moderat.sanierung.costs.';

  /**
   * if the user clicks on details.
   */
  onShowDetails(): void {
    this.financeDetails.emit();
  }
}
